import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { PageHeader, NativeSelect, Empty, DemoBadge } from "@/components/common";
import { CriticitaFormDialog, SEV_CLS, useMapMeta } from "@/components/CriticitaFormDialog";
import { fmtDT } from "@/lib/format";
import { cn } from "@/lib/utils";

export default function Criticita() {
  const meta = useMapMeta();
  const [sp, setSp] = useSearchParams();
  const [rows, setRows] = useState(null);
  const [open, setOpen] = useState(false);
  const params = Object.fromEntries(sp.entries());
  useEffect(() => {
    api.get("/criticita", { params: Object.fromEntries(sp.entries()) }).then((r) => setRows(r.data));
  }, [sp]);
  const setParam = (k, v) => {
    const n = new URLSearchParams(sp);
    if (v) n.set(k, v); else n.delete(k);
    setSp(n);
  };
  return (
    <div data-testid="criticita-page">
      <PageHeader title="Criticità" subtitle={rows ? `${rows.length} segnalazioni` : ""}
        actions={<Button onClick={() => setOpen(true)} className="h-11 rounded-xl font-bold" data-testid="criticita-new-button"><Plus className="mr-1 h-4 w-4" />Segnala</Button>} />
      <div className="mb-4 grid grid-cols-2 gap-2 sm:flex">
        <NativeSelect testid="cr-filter-open" value={params.open_only} onChange={(v) => setParam("open_only", v)}><option value="">Tutte</option><option value="true">Solo aperte</option></NativeSelect>
        <NativeSelect testid="cr-filter-status" value={params.status} onChange={(v) => setParam("status", v)}><option value="">Ogni stato</option>{meta && Object.entries(meta.statuses).map(([k, v]) => <option key={k} value={k}>{v}</option>)}</NativeSelect>
        <NativeSelect testid="cr-filter-severity" value={params.severity} onChange={(v) => setParam("severity", v)}><option value="">Ogni gravità</option>{meta?.severities.map((s) => <option key={s} value={s}>{s}</option>)}</NativeSelect>
      </div>
      {rows?.length === 0 && <Empty text="Nessuna criticità." testid="criticita-empty" />}
      <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-3">
        {rows?.map((c) => (
          <Link key={c.id} to={`/criticita/${c.id}`} data-testid={`criticita-card-${c.code}`}
            className={cn("card-soft block p-4 tile-press", !["chiusa", "annullata"].includes(c.status) && ["media", "alta", "emergenza"].includes(c.severity) && "border-l-4 border-l-red-500")}>
            <div className="flex items-center gap-2"><span className="font-mono text-xs text-muted-foreground">{c.code}</span>
              <span className={`rounded-full px-2 py-0.5 text-xs font-bold ${SEV_CLS[c.severity]}`}>{c.severity}</span><DemoBadge show={c.is_demo} />
              <span className="ml-auto rounded-full bg-muted px-2 py-0.5 text-xs font-semibold">{c.status_label}</span></div>
            <p className="mt-2 font-bold">{c.title}</p>
            <p className="mt-1 text-xs text-muted-foreground">{c.category_label} · {c.cimitero_name} · {c.area_label || "zona non indicata"} · {fmtDT(c.created_at)}</p>
          </Link>
        ))}
      </div>
      <CriticitaFormDialog open={open} onOpenChange={setOpen} />
    </div>
  );
}
